export default __webpack_public_path__ + "images/checkGreen.v-b376ba990c5cc07f97ec7580884399b1.svg";